export default "/_next/static/images/MembershipBG-be97b6c6c4434fd456ce051d475c117a.webp";